import { useQuery } from '@tanstack/react-query';
import { entriesApi } from '../../../../api/entries';
import { projectsApi } from '../../../../api/projects';
import { Project } from '../../../../types';
import CalendarView, { TimeEntryCalendar, formatDateKey } from '../../../../components/ui/organisms/calendar-view';
import { getPhaseName } from '../utils';

export function CalendarTab({
  weekStart, onWeekChange, onEditEntry,
}: {
  weekStart: Date;
  onWeekChange: (weekStart: Date) => void;
  onEditEntry: (entry: TimeEntryCalendar) => void;
}) {
  const calendarFrom = formatDateKey(weekStart);
  const calendarTo   = formatDateKey(new Date(weekStart.getTime() + 6 * 86400000));

  const { data: calendarData, isLoading } = useQuery({
    queryKey: ['my-calendar', calendarFrom, calendarTo],
    queryFn: () =>
      entriesApi.listMine({ from: calendarFrom, to: calendarTo, limit: 200 })
        .then((r) => r.data?.data ?? []),
  });

  const { data: projectsData } = useQuery({
    queryKey: ['projects'],
    queryFn: () => projectsApi.list().then((r) => r.data),
  });
  const projects: Project[] = projectsData ?? [];

  const calendarEntries: TimeEntryCalendar[] = (calendarData ?? []).map((e: any) => {
    const proj = e.project ?? projects.find((p) => p.id === e.projectId);
    return {
      id:       e.id,
      date:     e.date?.slice(0, 10) ?? '',
      fromHour: e.fromHour?.slice(11, 16) ?? e.fromHour ?? '00:00',
      toHour:   e.toHour?.slice(11, 16)   ?? e.toHour   ?? '00:00',
      hours:    e.hours,
      status:   e.status,
      notes:    e.notes,
      rejectionReason: e.rejectionReason,
      ownerEditable: e.ownerEditable,
      project:  {
        id: proj?.id ?? e.projectId,
        name: proj?.name ?? 'Unknown',
        status: proj?.status ?? projects.find((p) => p.id === (proj?.id ?? e.projectId))?.status,
      },
      phase:    e.phase    ?? (e.phaseId ? { id: e.phaseId, name: getPhaseName(projects, e) ?? '' } : null),
      jobTitle: e.jobTitle ?? { id: '', name: '' },
    };
  });

  return (
    <CalendarView
      entries={calendarEntries}
      onEditEntry={onEditEntry}
      isLoading={isLoading}
      weekStart={weekStart}
      onWeekChange={onWeekChange}
    />
  );
}
